import Amethyst from './Amethyst.png';
import Aquamarine from './Aquamarine.png';
import Artichoke_Dip from './Artichoke_Dip.png';
import Autumns_Bounty from './Autumns_Bounty.png';
import Banana_Pudding from './Banana_Pudding.png';
import Battery_Pack from './Battery_Pack.png';
import Bean_Hotpot from './Bean_Hotpot.png';
import Beer from './Beer.png';
import Beet from './Beet.png';
import Blackberry_Cobbler from './Blackberry_Cobbler.png';
import Blueberry_Tart from './Blueberry_Tart.png';
import Cactus_Fruit from './Cactus_Fruit.png';
import Catfish from './Catfish.png';
import Cauliflower from './Cauliflower.png';
import Cheese_Cauliflower from './Cheese_Cauliflower.png';
import Chocolate_Cake from './Chocolate_Cake.png';
import Cloth from './Cloth.png';
import Coconut from './Coconut.png';
import Coffee from './Coffee.png';
import Complete_Breakfast from './Complete_Breakfast.png';
import Crab_Cakes from './Crab_Cakes.png';
import Cranberry_Candy from './Cranberry_Candy.png';
import Crispy_Bass from './Crispy_Bass.png';
import Crocus from './Crocus.png';
import Daffodil from  './Daffodil.png';
import Diamond from './Diamond.png';
import Dish_o_The_Sea from './Dish_o_The_Sea.png';
import Duck_Feather from './Duck_Feather.png';
import Eggplant_Parmesan from './Eggplant_Parmesan.png';
import Emerald from './Emerald.png';
import Escargot from './Escargot.png';
import Fairy_Rose from './Fairy_Rose.png';
import Farmers_Lunch from './Farmers_Lunch.png';
import Fiddlehead_Risotto from './Fiddlehead_Risotto.png';
import Fish_Taco from './Fish_Taco.png';
import Fried_Calamari from './Fried_Calamari.png';
import Fried_Eel from './Fried_Eel.png';
import Fried_Mushroom from './Fried_Mushroom.png';
import Frozen_Tear from './Frozen_Tear.png';
import Fruit_Salad from './Fruit_Salad.png';
import Ginger_Ale from './Ginger_Ale.png';
import Glazed_Yams from './Glazed_Yams.png';
import Goat_Cheese from './Goat_Cheese.png';
import Gold_Bar from './Gold_Bar.png';
import Grape from './Grape.png';
import Green_Tea from './Green_Tea.png';
import Hot_Pepper from './Hot_Pepper.png';
import Ice_Cream from './Ice_Cream.png';
import Iridium_Bar from './Iridium_Bar.png';
import Jade from './Jade.png';
import Leek from './Leek.png';
import Lemon_Stone from './Lemon_Stone.png';
import Lobster from './Lobster.png';
import Mango_Sticky_Rice from './Mango_Sticky_Rice.png';
import Mango from './Mango.png';
import Maple_Bar from './Maple_Bar.png';
import Mead from './Mead.png';
import Melon from './Melon.png';
import Miners_Treat from './Miners_Treat.png';
import Obsidian from './Obsidian.png';
import Octopus from './Octopus.png';
import Omni_Geode from './Omni_Geode.png';
import Orange from './Orange.png';
import Ostrich_Egg from './Ostrich_Egg.png';
import Pale_Ale from './Pale_Ale.png';
import Pancakes from './Pancakes.png';
import Parsnip_Soup from './Parsnip_Soup.png';
import Parsnip from './Parsnip.png';
import Peach from './Peach.png';
import Pepper_Poppers from './Pepper_Poppers.png';
import Pickles from './Pickles.png';
import Pina_Colada from './Pina_Colada.png';
import Pink_Cake from './Pink_Cake.png';
import Pizza from './Pizza.png';
import Plum_Pudding from './Plum_Pudding.png';
import Poi from './Poi.png';
import Pomegranate from './Pomegranate.png';
import Poppy from './Poppy.png';
import Poppyseed_Muffin from './Poppyseed_Muffin.png';
import Pufferfish from './Pufferfish.png';
import Pumpkin_Pie from './Pumpkin_Pie.png';
import Pumpkin_Soup from './Pumpkin_Soup.png';
import Pumpkin from './Pumpkin.png';
import Purple_Mushroom from './Purple_Mushroom.png';
import Radioactive_Bar from  './Radioactive_Bar.png';
import Red_Plate from './Red_Plate.png';
import Rhubarb_Pie from './Rhubarb_Pie.png';
import Rice_Pudding from './Rice_Pudding.png';
import Roasted_Hazelnuts from './Roasted_Hazelnuts.png';
import Roots_Platter from './Roots_Platter.png';
import Ruby from './Ruby.png';
import Salad from './Salad.png';
import Salmon_Dinner from './Salmon_Dinner.png';
import Sandfish from './Sandfish.png';
import Sashimi from './Sashimi.png';
import Sea_Cucumber from './Sea_Cucumber.png';
import Snail from './Snail.png';
import Solar_Essence from './Solar_Essence.png';
import Spaghetti from './Spaghetti.png';
import Spicy_Eel from './Spicy_Eel.png';
import Squid_Ink from './Squid_Ink.png';
import Stir_Fry from './Stir_Fry.png';
import Strawberry from './Strawberry.png';
import Stuffing from './Stuffing.png';
import Sturgeon from './Sturgeon.png';
import Summer_Spangle from './Summer_Spangle.png';
import Sunflower from './Sunflower.png';
import Super_Cucumber from './Super_Cucumber.png';
import Super_Meal from './Super_Meal.png';
import Survival_Burger from './Survival_Burger.png';
import Sweet_Pea from './Sweet_Pea.png';
import Tigerseye from './Tigerseye.png';
import Tom_Kha_Soup from './Tom_Kha_Soup.png';
import Topaz from './Topaz.png';
import Tropical_Curry from './Tropical_Curry.png';
import Truffle_Oil from './Truffle_Oil.png';
import Truffle from './Truffle.png';
import Tulip from './Tulip.png';
import Vegetable_Medley from './Vegetable_Medley.png';
import Void_Egg from './Void_Egg.png';
import Void_Essence from './Void_Essence.png';
import Void_Mayonnaise from './Void_Mayonnaise.png';
import Wild_Horseradish from './Wild_Horseradish.png';
import Wine from './Wine.png';
import Wool from './Wool.png';
import Yam from './Yam.png';

const images = {
  Amethyst,
  Aquamarine,
  Artichoke_Dip,
  Autumns_Bounty,
  Banana_Pudding,
  Battery_Pack,
  Bean_Hotpot,
  Beer,
  Beet,
  Blackberry_Cobbler,
  Blueberry_Tart,
  Cactus_Fruit,
  Catfish,
  Cauliflower,
  Cheese_Cauliflower,
  Chocolate_Cake,
  Cloth,
  Coconut,
  Coffee,
  Complete_Breakfast,
  Crab_Cakes,
  Cranberry_Candy,
  Crispy_Bass,
  Crocus,
  Daffodil,
  Diamond,
  Dish_o_The_Sea,
  Duck_Feather,
  Eggplant_Parmesan,
  Emerald,
  Escargot,
  Fairy_Rose,
  Farmers_Lunch,
  Fiddlehead_Risotto,
  Fish_Taco,
  Fried_Calamari,
  Fried_Eel,
  Fried_Mushroom,
  Frozen_Tear,
  Fruit_Salad,
  Ginger_Ale,
  Glazed_Yams,
  Goat_Cheese,
  Gold_Bar,
  Grape,
  Green_Tea,
  Hot_Pepper,
  Ice_Cream,
  Iridium_Bar,
  Jade,
  Leek,
  Lemon_Stone,
  Lobster,
  Mango_Sticky_Rice,
  Mango,
  Maple_Bar,
  Mead,
  Melon,
  Miners_Treat,
  Obsidian,
  Octopus,
  Omni_Geode,
  Orange,
  Ostrich_Egg,
  Pale_Ale,
  Pancakes,
  Parsnip_Soup,
  Parsnip,
  Peach,
  Pepper_Poppers,
  Pickles,
  Pina_Colada,
  Pink_Cake,
  Pizza,
  Plum_Pudding,
  Poi,
  Pomegranate,
  Poppy,
  Poppyseed_Muffin,
  Pufferfish,
  Pumpkin_Pie,
  Pumpkin_Soup,
  Pumpkin,
  Purple_Mushroom,
  Radioactive_Bar,
  Red_Plate,
  Rhubarb_Pie,
  Rice_Pudding,
  Roasted_Hazelnuts,
  Roots_Platter,
  Ruby,
  Salad,
  Salmon_Dinner,
  Sandfish,
  Sashimi,
  Sea_Cucumber,
  Snail,
  Solar_Essence,
  Spaghetti,
  Spicy_Eel,
  Squid_Ink,
  Stir_Fry,
  Strawberry,
  Stuffing,
  Sturgeon,
  Summer_Spangle,
  Sunflower,
  Super_Cucumber,
  Super_Meal,
  Survival_Burger,
  Sweet_Pea,
  Tigerseye,
  Tom_Kha_Soup,
  Topaz,
  Tropical_Curry,
  Truffle_Oil,
  Truffle,
  Tulip,
  Vegetable_Medley,
  Void_Egg,
  Void_Essence,
  Void_Mayonnaise,
  Wild_Horseradish,
  Wine,
  Wool,
  Yam
}

export default images;
